import { useNavigate } from "react-router-dom";

const FoodLandingPage = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/login-food");
  };

  return (
    <main style={{ fontFamily: "sans-serif" }}>
      {/* Header */}
      <section
        style={{
          padding: "4rem 1rem",
          textAlign: "center",
          color: "black",
        }}
      >
        <h1
          style={{
            fontSize: "2.75rem",
            fontWeight: "bold",
            marginBottom: "1rem",
          }}
        >
          Track your food spending
        </h1>
        <p style={{ fontSize: "1.125rem", marginBottom: "2rem" }}>
          Upload receipts and track your grocery budget in seconds.
        </p>
        <button onClick={handleLoginRedirect} style={styles.primaryButton}>
          Get Started
        </button>
      </section>

      {/* Instructions */}
      <section
        style={{
          padding: "4rem 1rem",
          textAlign: "center",
          backgroundColor: "#f9fafb",
        }}
      >
        <h2
          style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "2rem" }}
        >
          How it works
        </h2>
        <ol
          style={{
            listStyle: "decimal",
            textAlign: "left",
            maxWidth: "600px",
            margin: "0 auto",
            fontSize: "1.125rem",
            color: "#374151",
            lineHeight: 2,
          }}
        >
          <li>Take a picture of your receipt</li>
          <li>Crop the image to show only the receipt</li>
          <li>Review and edit the parsed items</li>
          <li>Log your receipt to the cloud</li>
          <li>Track your grocery budget over time</li>
        </ol>
      </section>
    </main>
  );
};

const styles: Record<string, React.CSSProperties> = {
  primaryButton: {
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    backgroundColor: "#22c55e",
    color: "#fff",
    border: "none",
    borderRadius: "9999px",
    cursor: "pointer",
  },
};

export default FoodLandingPage;
